import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
 standalone: false,
  name: 'mxHtmlToText',
  pure: true,
})
export class MxHtmlToTextPipe implements PipeTransform {
  constructor() {}

  transform(value: any): any {
    const text = value.replace(/<[^>]+>/g, '');
    return text;
  }
}

